import React from 'react';
import CONSTANTS from '../Constants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { MaterialTextInput } from 'atoms/MaterialInput';
import { ButtonComp as Button } from 'atoms/Buttons';
import { submitFeedback } from '@kfc-global/react-shared/redux/Actions/FeedbackAction';
import { useDispatch, useSelector } from 'react-redux';
import ReCAPTCHA from 'react-google-recaptcha';
import { config } from '@kfc-global/react-shared/config/config.utils';
import { RECAPTCHA_SITE_KEY } from '@kfc-global/react-shared/config/config.constants';
import ModalComponent from 'molecules/Modal';
import { validateName, validatePhone, validateEmail, isValidForm, getFeebackRequest } from '../Utils/contactUsUtils';

const Alert = ({ onClickHandler }) => {
  return (
    <React.Fragment>
      <ModalComponent
        id='alertPop'
        role='dialog'
        show={true}
        classNames='conatct-us-alet-modal'
        closeDataTestId='handler-close'
        autoFocus={true}
      >
        <div className='submit-alert-conatiner'>
          <span className='alert-title'>{translateWithI18Next(CONSTANTS.feedbackSuccess)}</span>
          <span className='alert-message'>{translateWithI18Next(CONSTANTS.feedbackSuccessMessage)}</span>
          <Button onClickHandler={onClickHandler} className='redButton alert-button'>
            {translateWithI18Next(CONSTANTS.feedbackSuccessOk)}
          </Button>
        </div>
      </ModalComponent>
    </React.Fragment>
  );
};

const SelectOptions = ({
  arialabelledby,
  options,
  selectClassName,
  optionContainerClassName,
  optionClassName,
  onChange,
  testid,
}) => {
  const [showOptions, setShowOptions] = React.useState(false);
  return (
    <div
      aria-labelledby={arialabelledby}
      className='select-topic-selection-conatiner'
      onClick={() => setShowOptions(!showOptions)}
      onKeyPress={() => setShowOptions(!showOptions)}
    >
      <div tabIndex='0' className={`${selectClassName} ${showOptions ? ' inverted-arrow' : ''}`}>
        {options[0]?.value}
      </div>
      {showOptions && (
        <div className={optionContainerClassName} role='listbox'>
          {options.map(({ key, value }) => (
            <span
              role='listitem'
              tabIndex='0'
              className={optionClassName}
              onClick={() => onChange({ key, value })}
              key={key || value}
              onKeyPress={() => onChange({ key, value })}
            >
              {value}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

const LetUsKnowOptions = ({ options, selectedItem, SetformData }) => {
  return options.map(({ key, value }) => (
    <div class='form-radio-wrapper'>
      <input
        type='radio'
        key={key}
        value={value}
        id={value}
        checked={selectedItem.value === value}
        data-testid={value}
        onChange={e =>
          SetformData(data => ({
            ...data,
            selectedLetUsKnow: options.find(option => option.value === e.target.value),
          }))
        }
      />
      <label for={value}>
        <span>{value}</span>
      </label>
    </div>
  ));
};

const ContactUsBody = props => {
  const { bodyFormData, tenantId, history, isMobile } = props;
  const { headline, topicOptions } = bodyFormData;
  const [formSubmitted, SetFormSubmitted] = React.useState(false);
  const [reCaptchaToken, SetReCaptchaToken] = React.useState(undefined);
  const [formData, SetformData] = React.useState({
    wantToKnowText: '',
    selectedLetUsKnow: {},
    firstNameText: '',
    lastNameText: '',
    phoneNoText: '',
    emailText: '',
  });
  const dispatch = useDispatch();
  const feedBackResponse = useSelector(state => state.feedbackReducer?.response);

  const onTopicChangeHandler = ({ key }) => {
    const url = topicOptions[key].externalurl;
    if (url) {
      window.location.href = url;
    }
  };
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <h5 className='contactUs-title'>{headline}</h5>
      <div className='select-topic-container'>
        <h6 className='select-topic-label' id='listbox1label'>
          {translateWithI18Next(CONSTANTS.selectATopic)}
        </h6>
        <SelectOptions
          arialabelledby='listbox1label'
          options={topicOptions.map((t, key) => ({ key, value: t.linkText }))}
          selectClassName='select-topic-selection'
          optionContainerClassName='select-topic-option-conatiner'
          optionClassName='select-topic-option'
          onChange={onTopicChangeHandler}
          testid='select-topic'
        />
      </div>
      <div className='contactUs-questions-container'>
        <h6 className='questions-form-header'>{translateWithI18Next(CONSTANTS.questionForUs)}</h6>
        <span className='questions-form-subheader'>{translateWithI18Next(CONSTANTS.loveToHearFromYou)}</span>
        <div className='questions-form-container1'>
          <h6 className='container1-header'>{`${translateWithI18Next(CONSTANTS.wantToKnow)}`}</h6>
          <textarea
            className='container1-input'
            aria-label={translateWithI18Next(CONSTANTS.wantToKnow)}
            multiple={true}
            maxLength={200}
            value={formData.wantToKnowText}
            onChange={e => SetformData({ ...formData, wantToKnowText: e.target.value })}
            placeholder={translateWithI18Next(CONSTANTS.wantToKnowPlaceholder)}
            data-testid='wantToKnowText'
          />
        </div>
        <div className='questions-form-container2'>
          <fieldset>
            <legend className='container2-header'>{`${translateWithI18Next(CONSTANTS.letUsKnow)}`}</legend>
            <div className='radio-container'>
              <LetUsKnowOptions
                options={topicOptions[0].contents}
                selectedItem={formData.selectedLetUsKnow}
                SetformData={SetformData}
              />
            </div>
          </fieldset>
        </div>
        <div className='questions-form-container3'>
          <div className='container3-header-block'>
            <h6 className='container3-header'>{translateWithI18Next(CONSTANTS.contactInfoTitle)}</h6>
            {!isMobile && <p className='mandatory-note'>{translateWithI18Next(CONSTANTS.mandatorynote)}</p>}
          </div>
          <MaterialTextInput
            placeholder={`${translateWithI18Next(CONSTANTS.firstNamePlaceholder)}`}
            value={formData.firstNameText}
            onChange={e => SetformData({ ...formData, firstNameText: e.target.value })}
            inputClassName='input'
            autoComplete='on'
            containerClassName='input-conatiner'
            inputTestId={CONSTANTS.firstNamePlaceholder}
            error={formData?.firstNameText?.length !== 0 && !validateName(formData.firstNameText)}
            helperText={translateWithI18Next(CONSTANTS.firstNameHelpText)}
            helperTextClassName='error-text'
            aria-required='true'
            maxlength={13}
          />
          <MaterialTextInput
            placeholder={`${translateWithI18Next(CONSTANTS.lastNamePlaceHolder)}`}
            value={formData.lastNameText}
            onChange={e => SetformData({ ...formData, lastNameText: e.target.value })}
            inputClassName='input'
            autoComplete='on'
            containerClassName='input-conatiner'
            inputTestId={CONSTANTS.lastNamePlaceHolder}
            error={formData?.lastNameText?.length !== 0 && !validateName(formData.lastNameText)}
            helperText={translateWithI18Next(CONSTANTS.lastNameHelpText)}
            helperTextClassName='error-text'
            maxlength={13}
            aria-required='true'
          />
          <MaterialTextInput
            placeholder={`${translateWithI18Next(CONSTANTS.phonePlaceholder)}`}
            value={formData.phoneNoText}
            onChange={e => SetformData({ ...formData, phoneNoText: e.target.value })}
            inputClassName='input'
            autoComplete='on'
            containerClassName='input-conatiner'
            inputTestId={CONSTANTS.phonePlaceholder}
            error={formData?.phoneNoText?.length !== 0 && !validatePhone(formData.phoneNoText)}
            helperText={translateWithI18Next(CONSTANTS.phoneHelpText)}
            helperTextClassName='error-text'
            maxlength={10}
            aria-required='true'
          />
          <MaterialTextInput
            placeholder={`${translateWithI18Next(CONSTANTS.emailPlaceholder)}`}
            value={formData.emailText}
            onChange={e => SetformData({ ...formData, emailText: e.target.value })}
            inputClassName='input'
            autoComplete='on'
            containerClassName='input-conatiner'
            inputTestId={CONSTANTS.emailPlaceholder}
            error={formData?.emailText?.length !== 0 && !validateEmail(formData.emailText)}
            helperText={translateWithI18Next(CONSTANTS.emailHelpText)}
            helperTextClassName='error-text'
            aria-required='true'
          />
        </div>
        <div className='captcha'>
          <ReCAPTCHA
            sitekey={config(RECAPTCHA_SITE_KEY)} // RENDEV-16323 to get the Site key from keystore
            onChange={token => {
              SetReCaptchaToken(token);
            }}
          />
        </div>
        <div className='button-container'>
          <Button
            className='button whiteButton blackBorder contactus-button'
            ariaLable='Cancel'
            data-testid={CONSTANTS.cancelButtonText}
            onClickHandler={e => {
              e.preventDefault();
              history.push('/');
            }}
          >
            {translateWithI18Next(CONSTANTS.cancelButtonText)}
          </Button>
          <Button
            disabled={!isValidForm(formData, reCaptchaToken)}
            className='button blackButton contactus-button disabled'
            ariaLable='Submit'
            data-testid={CONSTANTS.submitButtonText}
            onClickHandler={e => {
              e.preventDefault();
              const request = getFeebackRequest(formData, tenantId, reCaptchaToken);
              dispatch(submitFeedback(request));
              SetFormSubmitted(() => true);
            }}
          >
            {translateWithI18Next(CONSTANTS.submitButtonText)}
          </Button>
        </div>
      </div>
      {feedBackResponse && formSubmitted ? (
        <Alert
          onClickHandler={() => {
            history.push('/');
          }}
        />
      ) : null}
    </>
  );
};
export default ContactUsBody;
